import {
  adminclassMentorGraduatesTermStorage,
  selectedRoleStorage,
  store,
} from '@/store'
import { SelectedRoleEnum } from '@/store/types'
import { SemesterInfo } from '@/types'

import { getAdminclassMentorRoleList, getRoleList } from './data'

/**
 * 初始化角色和行政班导师信息
 *
 * @param semesterInfo - 学期
 */
export const initStoreRoleAndGraduatesTermName = (
  semesterInfo: SemesterInfo
) => {
  const storedRole = store.get(selectedRoleStorage)
  const storedGraduatesTermName = store.get(
    adminclassMentorGraduatesTermStorage
  )

  const { adminclassTermNames } = getAdminclassMentorRoleList(semesterInfo)

  const roleKeys = getRoleList(semesterInfo).map((r) => r.key)

  // 如果只是行政班导师
  if (semesterInfo?.is_adminclass_mentor === 1 && roleKeys.length === 1) {
    // 如果本地存储的角色不是行政班导师，就用行政班导师
    if (storedRole !== SelectedRoleEnum.AdminclassMentor) {
      store.set(selectedRoleStorage, SelectedRoleEnum.AdminclassMentor)
      store.set(adminclassMentorGraduatesTermStorage, adminclassTermNames[0])
      return
    }
    // 如果本地存储的届别信息不在行政班导师列表中，就用第一个
    if (!adminclassTermNames.includes(storedGraduatesTermName)) {
      store.set(adminclassMentorGraduatesTermStorage, adminclassTermNames[0])
      return
    }
    return
  }

  if (!roleKeys.length) {
    store.set(selectedRoleStorage, undefined)
    store.set(adminclassMentorGraduatesTermStorage, undefined)
  }

  if (roleKeys.length && (!storedRole || !roleKeys.includes(storedRole))) {
    store.set(selectedRoleStorage, roleKeys[0])
  }

  if (
    storedRole === SelectedRoleEnum.AdminclassMentor &&
    (!storedGraduatesTermName ||
      !adminclassTermNames.includes(storedGraduatesTermName))
  ) {
    store.set(adminclassMentorGraduatesTermStorage, adminclassTermNames[0])
  }
}
